import React, { useState, useEffect } from 'react';
import '../../css/faq.css';

const FAQ = () => {
  const [openItems, setOpenItems] = useState([]);
  const [allExpanded, setAllExpanded] = useState(false);

  const faqs = [
    {
      question: 'What is UnsupervisedBias?',
      answer: 'UnsupervisedBias is an AI-powered data accessibility consultation service that provides secure and detailed insights from your data. We are able to tailor solutions to suit your needs because we build everything from scratch: chatbots, automated data piplines, and even this website!'
    },
    {
      question: 'How can I demo the chatbot to chat with my own files?',
      answer: (
        <>
          <a href="https://ai.unsupervisedbias.com" target="_blank" rel="noopener noreferrer">Click here to try our Free Demo: Chat with your Documents.</a>
          <br /><br />
          Our demo is free to use and does not require an account. You can upload your own files to the chatbot and ask questions about them. The chatbot will provide answers with references to the document titles and page numbers.
        </>
      )
    },
    {
      question: 'Can I create a custom chatbot for my business?',
      answer: (
        <>
          Yes, we can create both internal and customer facing custom chatbots for your business. We will train the chatbot on your documents and provide a custom interface for your website.
          <br /><br />
          The chatbot will provide 24/7 customer support, generate leads with automated data funnels, and make suggestions to increase sales.
          <br /><br />
          <a href="/contact">Contact Us</a> to request more information or <a href="/contact">Book a Call</a> to set up a time to discuss how we can implement this for you.
        </>
      )
    },
    {
      question: 'Can I put a chatbot bubble on my own website?',
      answer: (
        <>
          Yes, we can create a customer facing chatbot bubble for your website. For reference, you can see our <b>customer chatbot</b> in the lower right hand corener of our website. We will train your chatbot on your company documents to provide customer facing support.
          <br /><br />
          The chatbot will provide 24/7 customer support, generate leads with automated data funnels, and make suggestions to increase sales.
          <br /><br />
          <a href="/contact">Contact Us</a> to request more information via email or <a href="/contact">Book a Call</a> to set up a time to discuss how we can implement this for you.
        </>
      )
    },
    {
      question: 'How does the custom AI chatbot work?',
      answer: 'Upload your documents to the chatbot\'s knowledge base using a drag-and-drop file upload system. The files are encrypted and stored in a vector database for reference by the chatbot. At this point you can immediately start asking questions about your documents. The chatbot will attach a list of references, including document titles and page numbers, to each of its responses. This can be useful if you want to know where the information came from for further reading. This also proves that the AI is not hallucinating, which means it is not making up seemingly true, yet false, information. Listing references is an option that you can toggle if you prefer to reduce clutter from the chat.'
    },
    {
      question: 'How do I upload more files to the chatbot?',
      answer: 'Upload your documents to the chatbot\'s knowledge base using a drag-and-drop file upload system. The files are encrypted and stored in a vector database for reference by the chatbot.'
    },
    {
      question: 'Are the documents that I upload to the chatbot kept private and secure?',
      answer: 'Yes, your documents are kept private and secure. We do not share your information with any other companies. We primarily use Google and Microsoft services. The documents that you upload are as secure as the emails you send on Gmail/Outlook. They are encrypted and not shared with anyone, so no one can read them, including us.'
    },
    {
      question: 'How do I manage which files the chatbot has access to?',
      answer: 'You can add and remove files from the folder that is linked for your account. You can also manage the files from within the chat application using "Upload Files" to add files to your folder and "Remove" to remove a particular file from your folder.'
    },
    {
      question: 'How can I contact UnsupervisedBias?',
      answer: (
        <>
          You can reach us by email at <a href="mailto:support@unsupervisedbias.com">support@unsupervisedbias.com</a>.
        </>
      )
    }
  ];

  const toggleFAQ = (index) => {
    if (openItems.includes(index)) {
      setOpenItems(openItems.filter(item => item !== index));
    } else {
      setOpenItems([...openItems, index]);
    }
  };

  const toggleExpandAll = () => {
    if (allExpanded) {
      setOpenItems([]);
      setAllExpanded(false);
    } else {
      setOpenItems(faqs.map((_, index) => index));
      setAllExpanded(true);
    }
  };

  // Sync allExpanded state when items are manually toggled
  useEffect(() => {
    setAllExpanded(openItems.length === faqs.length);
  }, [openItems, faqs.length]);

  return (
    <main>
      <section className="faq-section">
        <div className="container">
          <div className="faq-header">
            <h1>Frequently Asked Questions</h1>
            <button onClick={toggleExpandAll} className="expand-all-btn">
              {allExpanded ? 'Collapse All' : 'Expand All'}
            </button>
          </div>
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <h3 onClick={() => toggleFAQ(index)}>
                <i className={`fas ${openItems.includes(index) ? 'fa-chevron-down' : 'fa-chevron-up'} arrow`}></i>
                {faq.question}
              </h3>
              <p className={openItems.includes(index) ? 'active' : ''}>
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default FAQ;
